var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeaderBlob1 = function SvgHeaderBlob1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 464,
    height: 608,
    viewBox: "0 0 464 608",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.112 18.8775C164.677 32.4158 208.166 69.3341 260.228 95.2672C326.802 128.43 425.037 123.888 455.31 191.825C485.166 258.827 421.769 329.553 395.069 397.875C370.265 461.346 360.702 536.365 305.21 575.918C249.874 615.359 175.705 609.389 108.112 602.409C46.4609 596.042 -15.6553 579.789 -61.4731 538.05C-104.604 498.759 -124.306 440.641 -132.826 382.922C-140.325 332.116 -109.586 286.245 -106.206 235C-101.082 157.303 -162.87 62.4159 -108.042 7.12599C-55.9586 -45.396 36.1758 1.66039 108.112 18.8775Z",
    fill: "#582BEE",
    fillOpacity: 0.07
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeaderBlob1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/header_blob_1.920fc3cb.svg";
export { ForwardRef as ReactComponent };